import ewbApi from "network/ewbApi";
import { NAVIGATION_MENU } from "network/endpoints";

export const fetchPersonalMenu = () => ewbApi.get(NAVIGATION_MENU.personalMenu);

export const fetchBusinessMenu = () => ewbApi.get(NAVIGATION_MENU.businessMenu);

export const fetchCustomerSupportMenu = () =>
  ewbApi.get(NAVIGATION_MENU.customerSupportMenu);

export const fetchAboutUsMenu = () => ewbApi.get(NAVIGATION_MENU.aboutUsMenu);
export const fetchFooterSitemap = () =>
  ewbApi.get(NAVIGATION_MENU.footerSitemap);
